import React, { useState } from "react";
import { useDispatch } from "react-redux";

import {
  toggleViewMoreAnnuouncementModal,
  updateClickAnnouncementId,
} from "@/reducers/clientAnnouncement";

const AnnouncementReadMoreWrapper = ({
  text = "",
  max = 200,
  cls = "",
  announcement_id = "",
}) => {
  const [showExtraText, setShowExtraText] = useState(false);
  const dispatch = useDispatch();
  return (
    <div className={cls}>
      {text.length > max ? (
        <>
          <p className="inline break-all">
            {text.substring(0, max)}
            {showExtraText ? text.substring(max, text.length) : "..."}
          </p>
          <button
            className="select-none text-primary hover:font-semibold"
            onClick={() => {
              dispatch(updateClickAnnouncementId(announcement_id));
              dispatch(toggleViewMoreAnnuouncementModal(true));
            }}
          >
            &nbsp; Read More
          </button>
        </>
      ) : (
        <p className="inline">{text}</p>
      )}
    </div>
  );
};

export default AnnouncementReadMoreWrapper;
